import groupTemplate from './group.pug';
import listTemplate from './list/list.pug';
import formTemplate from './form/form.pug';
import viewTemplate from './view/view.pug';
import summaryTemplate from './view/summary/summary.pug';
import attributesTemplate from './view/attributes/attributes.pug';
import memberListTemplate from '../member/list/list.pug';
import reportsTemplate from './view/reports/reports.pug';
import settingsTemplate from './view/settings/settings.pug';
import settingsOverviewTemplate from './view/settings/overview.pug';

'use strict';

export default ['$stateProvider', function routes($stateProvider) {
  $stateProvider
    .state('group', {
      url: '/context/:ctxId',
      abstract: true,
      template: groupTemplate,
      controller: 'GrpCtxCtrl',
      controllerAs: 'ctxvm',
      authenticate: true
    })
    .state('group.list', {
      url: '/grouptypes/:typeId',
      template: listTemplate,
      controller: 'GroupListCtrl',
      controllerAs: 'grplsvm',
      authenticate: true,
      // prevent reload on url query string updates (filter)
      reloadOnSearch: false
    })
    .state('group.new', {
      url: '/grouptypes/:typeId/groups/new',
      template: formTemplate,
      controller: 'GroupFormCtrl',
      controllerAs: 'vm',
      authenticate: true
    })
    .state('group.view', {
      url: '/groups/:groupId', // :groupId = ancestor/context group
      template: viewTemplate,
      controller: 'GroupViewCtrl',
      abstract: true,
      controllerAs: 'grpvm',
      authenticate: true
    })
    .state('group.edit', {
      url: '/groups/:groupId/edit', // :groupId = ancestor/context group
      template: formTemplate,
      controller: 'GroupFormCtrl',
      controllerAs: 'vm',
      authenticate: true
    })
    .state('group.view.summary', {
      url: '',
      template: summaryTemplate,
      authenticate: true
    })
    .state('group.view.attributes', {
      url: '/attributes',
      template: attributesTemplate,
      controller: 'GroupAttributesCtrl',
      controllerAs: 'gavm',
      authenticate: true
    })
    .state('group.view.members', {
      url: '/members',
      template: memberListTemplate,
      controller: 'MemberListCtrl',
      controllerAs: 'memvm',
      authenticate: true,
      // prevent reload on url query string updates (filter)
      reloadOnSearch: false
    })
    .state('group.view.grplist', {
      url: '/grouptypes/:typeId',
      template: listTemplate,
      controller: 'GroupListCtrl',
      controllerAs: 'grplsvm',
      authenticate: true,
      // prevent reload on url query string updates (filter)
      reloadOnSearch: false
    })
    .state('group.view.reports', {
      url: '/reports',
      template: reportsTemplate,
      controller: 'GroupReportsCtrl',
      controllerAs: 'grepvm',
      authenticate: true
    })
    .state('group.view.settings', {
      url: '',
      template: settingsTemplate,
      abstract: true,
      authenticate: true
    })
    .state('group.view.settings.overview', {
      url: '/settings',
      template: settingsOverviewTemplate,
      controller: 'GroupSettingsOverviewCtrl',
      controllerAs: 'ovm',
      authenticate: true
    });
}];
